import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ContactoAseguradorasService } from './shared/contacto-aseguradoras.service';
import { ToastrService } from 'ngx-toastr';
import { RamoService } from '../ramo/shared/ramo.service';
import { AseguradorasService } from '../aseguradoras/shared/aseguradoras.service';
import { CiudadesServiceService } from '../ciudades/shared/ciudades-service.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import 'datatables.net';
import 'datatables.net-bs4';
import * as $ from 'jquery';
import { ContactoAseguradoras } from './shared/contacto-aseguradoras.model';
import { Select2OptionData } from 'ng-select2';

@Component({
  selector: 'app-contacto-aseguradoras',
  templateUrl: './contacto-aseguradoras.component.html',
  styleUrls: ['./contacto-aseguradoras.component.css']
})

export class ContactoAseguradorasComponent implements OnInit {
  formContactoAse: FormGroup;
  edit: boolean;

  datatable: any;

  ListContAsegu: ContactoAseguradoras[] = [];
  ListAseguradoras: Array<Select2OptionData> = [];
  ListRamos: Array<Select2OptionData> = [];
  ListCiudades: Array<Select2OptionData> = [];

  constructor(
    public contactoAseService: ContactoAseguradorasService,
    private toastr: ToastrService,
    private ramoService: RamoService,
    private aseguradoraService: AseguradorasService,
    private ciudadService: CiudadesServiceService,
    private _fb: FormBuilder,
    private chRef: ChangeDetectorRef

  ) {  }

  ngOnInit() {
    this.initForm();    
    this.loadSelects();
    //this.refreshList();
    this.getContactAseguradoras();

  }

  refreshList() {
    this.contactoAseService.getContactoAseguradora();
  }

  getContactAseguradoras() {
    this.contactoAseService.getContactoAseguradora().then(r => {

      if ($.fn.dataTable.isDataTable('#datatable')) {
        this.datatable.destroy();
      }

      this.ListContAsegu = r as ContactoAseguradoras[];

      this.chRef.detectChanges();

      const table: any = $('#datatable');
      this.datatable = table.DataTable({
        responsive: true
      })

    });
  }

  initForm() {
    this.formContactoAse = this._fb.group({
      idAdmAseguradoraRamoTelefono: 0,
      idAdmAseguradora: [[''], [Validators.required]],
      idAdmRamo: [[''], [Validators.required]],
      idAdmCiudad: [[''], [Validators.required]],
      numero: ["", [Validators.required]],
      celular: ["", [Validators.required]],
      lineaNacional: ["", [Validators.required]],
    });
  }

  onSubmit() {
    this.insertContactoAse();
  }


  insertContactoAse() {
    this.contactoAseService.postContactoAseguradora(this.formContactoAse.value).then(r => { this.toastr.success("Registrado correctamente"); this.getContactAseguradoras(); })//TODO: validar los mensaje y valores de retorno por la respuesta
  }

  loadSelects() {
    this.aseguradoraService.getAseguradoras().then(r => {
      let list: Select2OptionData[] = [];
      if (this.aseguradoraService.listAseguradora != null) {
        list.push({ id: '-1', text: 'Seleccione' });
        this.aseguradoraService.listAseguradora.forEach(item => {
          list.push({ id: item.idAdmAseguradora.toString(), text: item.nombre });
        });
      }

      this.ListAseguradoras = list;
    });

    this.ramoService.getRamo().then(r => {
      let list: Select2OptionData[] = [];
      if (this.ramoService.listRamo != null) {
        list.push({ id: '-1', text: 'Seleccione' });
        this.ramoService.listRamo.forEach(item => {
          list.push({ id: item.idAdmRamo.toString(), text: item.nombre });
        });
      }

      this.ListRamos = list;      
    });

    this.ciudadService.getCitys().then(r => {
      let list: Select2OptionData[] = [];
      if (this.ciudadService.listCitys != null) {
        list.push({ id: '-1', text: 'Seleccione' });
        this.ciudadService.listCitys.forEach(item => {
          list.push({ id: item.idAdmCiudad.toString(), text: item.nombre });
        });
      }

      this.ListCiudades = list;          
    });
  }

  getAseguradoraToEdit(id: number) {
    this.contactoAseService.getContactoById(id).then(r => { this.loadFieldEdit() });
  }

  loadFieldEdit() {
    this.edit = true;
    this.formContactoAse.patchValue({
      idAdmAseguradoraRamoTelefono: this.contactoAseService.contactoAse.idAdmAseguradoraRamoTelefono,
      idAdmAseguradora: this.contactoAseService.contactoAse.idAdmAseguradora,
      idAdmRamo: this.contactoAseService.contactoAse.idAdmRamo,
      idAdmCiudad: this.contactoAseService.contactoAse.idAdmCiudad,
      numero: this.contactoAseService.contactoAse.numero,
      celular: this.contactoAseService.contactoAse.celular,
      lineaNacional: this.contactoAseService.contactoAse.lineaNacional
    });
  }

  resetForm() {
    this.formContactoAse.reset();
  }

  update() {
    this.contactoAseService.updateContactoAse(this.formContactoAse.value, this.formContactoAse.get('idAdmAseguradoraRamoTelefono').value)
      .then(r => { this.edit = false; this.getContactAseguradoras(); this.resetForm(); this.toastr.success("Actualizado correctamente") });
  }

  deleteAseguradora(id: number) {
    this.contactoAseService.deleteContactoAse(id).then(r => { this.getContactAseguradoras(); this.resetForm(); this.toastr.warning("Eliminado correctamente") });
  }
}
